import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject, takeUntil } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { isSuperAdmin } from 'app/shared/utils';
import { Company } from 'app/modules/models/company.type';
import {Store} from "@ngrx/store";
import {setCurrentCompany} from "../../../ngrx/actions/company.actions";
import { StoreService } from '../../../ngrx/store.service';
import { AcepActeur } from 'app/modules/models/acepActeur.type';

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'user',
})
export class UserComponent implements OnInit, OnDestroy {
  /* eslint-disable @typescript-eslint/naming-convention */
  static ngAcceptInputType_showAvatar: BooleanInput;
  /* eslint-enable @typescript-eslint/naming-convention */

  @Input() showAvatar: boolean = true;
  avatar: string = '';
  user: User;
  selectedPartner: any;
  company: Company;
  isSuperAdmin: boolean = false;
  isPartnerAdmin: boolean = false;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  selectedMandataire: any;
  selectedPartnerFromAdmin_Mandate: any;
  selectedMandataireOfCurrentPartner: AcepActeur[] | null;
  tousLesPartenaires: boolean;

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private _userService: UserService,
    private readonly store: Store,
    private readonly storeService:StoreService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to user changes
    this._userService.connectedUser$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((user: User) => {
        this.user = user;
        this.avatar = 'data:image/png;base64,' + user?.avatar;
        this.selectedPartner = this.storeService.getUserPartner();
        this.selectedPartner ?
          this.company = this.selectedPartner :
          this.company = this.user?.company;
        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
      this.isSuperAdmin = isSuperAdmin();
      this.isPartnerAdmin = this.storeService.IsPartnerAdmin();
      this.company = this.user.company; 
      this.storeService.setCurrentCompany(this.company);
      this.store.dispatch(setCurrentCompany({ company: this.company  }));
      this.company?.name.length > 20 ? this.company.name = this.company.name.substring(0, 20) + '...' : this.company.name;
      this.selectedMandataire = localStorage.getItem('currentMandataire_localstorage') ? JSON.parse(localStorage.getItem('currentMandataire_localstorage')) : null;
      this.selectedPartnerFromAdmin_Mandate = localStorage.getItem('currentPartner_localstorage') ? JSON.parse(localStorage.getItem('currentPartner_localstorage')) : null;
      this.selectedMandataireOfCurrentPartner = localStorage.getItem('mandataireOfCurrentPartner_localstorage') ? JSON.parse(localStorage.getItem('mandataireOfCurrentPartner_localstorage')) : null;
      this.tousLesPartenaires = localStorage.getItem('tousPartenaires_localstorage') ? JSON.parse(localStorage.getItem('tousPartenaires_localstorage')) : false;
  } 

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the user status
   *
   * @param status
   */
  updateUserStatus(status: string): void {
    // Return if user is not available
    if (!this.user) {
      return;
    }

    // Update the user
    this._userService
      .update({
        ...this.user,
        status,
      })
      .subscribe();
  }

  /**
   * Sign out
   */
  signOut(): void {
    this._router.navigate(['/sign-out']);
  }

  goTo(page): void {
    localStorage.removeItem('currentMandataire_localstorage');
    localStorage.removeItem('currentPartner_localstorage');
    localStorage.removeItem('tousPartenaires_localstorage');
    localStorage.removeItem('mandataireOfCurrentPartner_localstorage');
    this._router.navigate([page]);
  }

  getUserRoles(): string {
    if (!this.user || !this.user.user_UserProfiles) {
      return '';
    }
  
    return this.user.user_UserProfiles
      .map(profile => profile.userProfile?.name) // Mappe les noms des profils
      .filter(Boolean) // Filtre les noms non définis ou null
      .join(', '); // Combine les noms avec une virgule
}
  }
  
